/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { AbstractControl } from '@angular/forms';
import { NgfForm } from '@ng-falcon/ngf-form/+model/ngf-form';
import { NgfFormArray } from '@ng-falcon/ngf-form/+model/ngf-form-array';
import { NgfFormControl } from '@ng-falcon/ngf-form/+model/ngf-form-control';
import { NgfFormGroup } from '@ng-falcon/ngf-form/+model/ngf-form-group';

export type NgfAbstractControl =
  | NgfFormControl<unknown>
  | NgfFormGroup<unknown>
  | NgfFormArray<AbstractControl<unknown>>
  | NgfForm<unknown>;

export function isNgfAbstractControl(control: AbstractControl | NgfAbstractControl): control is NgfAbstractControl {
  return control instanceof NgfFormControl
    || control instanceof NgfFormGroup
    || control instanceof NgfFormArray
    || control instanceof NgfForm;
}
